<div class="posts-container" *ngIf="posts">
  <div class="header-text" *ngIf="!headerText && showHeader">{{'INFLUENCER.insight.platform_reach.title' | translate}}</div>
  <div class="header-text" *ngIf="headerText && showHeader">{{headerText}}</div>
  <div class="d-flex flex-row align-items-center post"
    *ngFor="let item of posts; let i = index;"
    [ngClass]="{'odd': i % 2 !== 0, 'even': i % 2 === 0}">
    <div class="d-flex flex-g1">
      <div class="select-campaign-post d-flex justify-content-center align-items-center">
        <achoo-checkbox name="campaign_post_{{item.urlHash}}"
                        (selectEvent)="onSelectPost(item)"
                        [(model)]="item.selected">
        </achoo-checkbox>
      </div>
      <div class="d-flex img-wrapper">
        <blurry-backdrop-image class="post-img" [image]="item.imageUrl" (afterLoaded)="onLoadedImage()"></blurry-backdrop-image>
      </div>
    </div>
    <div class="d-flex flex-g2 flex-column details" (click)="goToPost(item.fullUrl, item.relativePath, item.urlHash)">
      <div class="title ellipsis" title="{{item.title}}">
        {{item.title}}
      </div>
      <div class="date">
        {{item.date | date:'dd MMM yyyy' }}
      </div>
    </div>
    <div class="d-flex flex-row flex-g2">
      <div class="d-flex flex-auto align-items-center">
        <div class="new-published-post" *ngIf="item.isNew">{{'INFLUENCER.campaign.new_post' | translate}}</div>
      </div>
      <div class="d-flex justify-content-end">
        <img *ngIf="item.platformBlogs" src="/assets/images/platform/Blogger.svg" class="platform-icon">
        <img *ngIf="item.platformFacebook" src="/assets/images/platform/Facebook.svg" class="platform-icon">
        <img *ngIf="item.platformInstagram" src="/assets/images/platform/Instagram.svg" class="platform-icon">
        <img *ngIf="item.platformYoutube" src="/assets/images/platform/Youtube.svg" class="platform-icon">
        <img *ngIf="item.platformSnapchat" src="/assets/images/platform/Snapchat.svg" class="platform-icon">
        <img *ngIf="item.platformTwitter" src="/assets/images/platform/Twitter.svg" class="platform-icon">
        <img *ngIf="item.platformPinterest" src="/assets/images/platform/Printerest.svg" class="platform-icon">
        <img *ngIf="item.platformTiktok" src="/assets/images/platform/TikTok.svg" class="platform-icon">
      </div>
    </div>
    <div class="d-flex flex-g2 justify-content-end">
      <div class="d-flex flex-column justify-content-center influencer-number-wrapper">
        <div class="d-flex flex-row">
          <div class="influencer-info-wrapper top left influencer-number-info d-flex flex-column">
            <div class="number-title d-flex justify-content-end">{{'common.measure.kpi_name.reach' | translate}}</div>
            <div class="number-data d-flex justify-content-end"
                 placement="bottom"
                 ngbTooltip="{{'info_box.influencer.reach' | translate}}">{{item.reach | thousandNumberSuffix}}</div>
          </div>
          <div class="influencer-info-wrapper top right d-flex flex-column">
            <div class="number-title d-flex justify-content-start">{{'common.measure.kpi_name.engagement' | translate}}</div>
            <div class="number-data d-flex justify-content-start"
                 placement="bottom-right"
                 ngbTooltip="{{'info_box.influencer.engagement' | translate}}">{{item.engagement | thousandNumberSuffix}}</div>
          </div>
        </div>
        <div class="seperate-influencer-line"></div>
        <div class="d-flex flex-row">
          <div class="influencer-info-wrapper bottom left influencer-number-info d-flex flex-column justify-content-end">
            <div class="number-title avg-reach d-flex justify-content-end">{{'common.measure.kpi_name.impressions' | translate}}</div>
            <div class="number-data d-flex justify-content-end"
                 placement="bottom"
                 ngbTooltip="{{'info_box.influencer.impression' | translate}}">
              {{item.impressions | thousandNumberSuffix}}
            </div>
          </div>
          <div class="influencer-info-wrapper bottom right d-flex flex-column">
            <div class="number-title d-flex justify-content-start">{{'common.measure.kpi_name.impact' | translate}}</div>
            <div class="number-data d-flex justify-content-start"
                 placement="bottom-right"
                 ngbTooltip="{{'info_box.influencer.impact' | translate}}">
              {{item.impact * 100 | percentNumberSuffix}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="msg" *ngIf="posts && posts.length===0">There's no post available for this campaign</div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/campaign-influencer-posts/campaign-influencer-posts.component.html